var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextPagination({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_1513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8143 14.2628C4.6562 14.1047 4.57715 13.9175 4.57715 13.7013C4.57715 13.4854 4.6562 13.2984 4.8143 13.1403L9.44671 8.50791L4.79849 3.85968C4.65093 3.71212 4.57715 3.52767 4.57715 3.30632C4.57715 3.08498 4.6562 2.89526 4.8143 2.73715C4.97241 2.57905 5.1596 2.5 5.37588 2.5C5.59175 2.5 5.77873 2.57905 5.93683 2.73715L11.2491 8.06522C11.3123 8.12846 11.3572 8.19697 11.3838 8.27075C11.4099 8.34453 11.423 8.42358 11.423 8.50791C11.423 8.59223 11.4099 8.67128 11.3838 8.74506C11.3572 8.81884 11.3123 8.88735 11.2491 8.95059L5.92102 14.2787C5.77346 14.4262 5.59175 14.5 5.37588 14.5C5.1596 14.5 4.97241 14.4209 4.8143 14.2628Z",
    fill: "#002466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_1513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPagination);
export default __webpack_public_path__ + "static/media/next_pagination.42419297ef9a3c3a2bc41c3edeb0324b.svg";
export { ForwardRef as ReactComponent };